import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import QuestionPreview from '../../QuestionPreview/QuestionPreview'
import SurveyBuilderQuestionAccordion from '../../Presentation/components/SurveyBuilderQuestionAccordion'
import Button from '../../../UniformComponents/Button'

@observer
class QuestionElement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowingPreview: false,
        }
    }

    togglePreview = async () => {
        const { store, question } = this.props
        try {
            const questionRes = await store.http.get(`/api/question/${question.questionId}/7`)
            this.questionFull = questionRes.question
            this.setState((prevState) => ({ isShowingPreview: !prevState.isShowingPreview }))
        } catch (e) {
            this.setState({ isShowingPreview: false })
        }
    }

    renderAddOptionButton = () => {
        const { stage, editQuestion } = this.props
        const isMissingOptionsModal = stage === 2

        if (isMissingOptionsModal) {
            return (
                <Button onClick={editQuestion}>
                    {i18n.t('surveyBuilder.modal.missingoptions.btn1')}
                </Button>
            )
        }
    }

    render() {
        const {
            question, title, store,
        } = this.props
        const { isShowingPreview } = this.state

        return (
            <>
                <SurveyBuilderQuestionAccordion
                    isLite
                    titleContent={title}
                    question={question}
                    onClick={this.togglePreview}
                    addOptionButton={this.renderAddOptionButton}
                />
                {isShowingPreview
                    && (
                        <div className="preview">
                            <QuestionPreview isLite store={store} question={this.questionFull} />
                        </div>
                    )}
            </>
        )
    }
}

export default QuestionElement
